import { environment } from '../../../environments/environment';
import { Currency, ITokenData } from '../interfaces/wallet.interface';
import { ERC_20_TOKEN, multiRouterContract, } from './wallet-connect.const';
import { formatUnits } from "viem";

const externalTokenListTest_: ITokenData[] = [];
const externalTokenListTest: ITokenData[] = [
  {
    name: "Mine Token",                                     //  0
    symbol: "MT",
    category: "ETH",
    image: "/assets/images/svg-icons/floki-with-eth.svg",
    address: "0x910C3B4fc0bBCfE4e84DF95c60b56E7Ef6B960D8",
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: [
      "0x910C3B4fc0bBCfE4e84DF95c60b56E7Ef6B960D8",
      "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
    ],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: "getAmountsOut", // v2
  }
]
const externalTokenListMain: ITokenData[] = [
  // ============================ ETH ============================
  {
    name: 'Lido Staked Ether',
    symbol: 'stETH',
    category: 'ETH',
    image: '/assets/images/svg-icons/steth.svg',
    address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Wrapped BTC',
    symbol: 'WBTC',
    category: 'ETH',
    image: '/assets/images/svg-icons/wrapped-btc.svg',
    address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    chainId: environment.eth.chainIdInt,
    decimal: 8,
    routerPath: ['0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [500],
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'Wrapped stETH',
    symbol: 'wstETH',
    category: 'ETH',
    image: '/assets/images/svg-icons/wsteth.svg',
    address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [100],
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'ChainLink Token',
    symbol: 'LINK',
    category: 'ETH',
    image: '/assets/images/svg-icons/link-token.svg',
    address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x514910771AF9Ca656af840dff83E8264EcF986CA', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [3000],
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'NEAR',
    symbol: 'NEAR',
    category: 'ETH',
    image: '/assets/images/svg-icons/near-eth.svg',
    address: '0x85f17cf997934a597031b2e18a9ab6ebd4b9f6a4',
    chainId: environment.eth.chainIdInt,
    decimal: 24,
    // NEAR -> USDC -> WETH
    routerPath: ['0x85f17cf997934a597031b2e18a9ab6ebd4b9f6a4', '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [3000, 500], // NEAR-USDC, USDC-WETH
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'Wrapped eETH',
    symbol: 'weETH',
    category: 'ETH',
    image: '/assets/images/svg-icons/weeth.svg',
    address: '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [100],
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'SHIBA INU',
    symbol: 'SHIB',
    category: 'ETH',
    image: '/assets/images/svg-icons/shiba-inu.svg',
    address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Coinbase Wrapped BTC',
    symbol: 'cbBTC',
    category: 'ETH',
    image: '/assets/images/svg-icons/cbbbtc.svg',
    address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    chainId: environment.eth.chainIdInt,
    decimal: 8,
    // cbBTC -> WBTC -> WETH
    routerPath: ['0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf', '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [100, 500], // cbBTC-WBTC, WBTC-WETH
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'Tether Gold',
    symbol: 'XAUt',
    category: 'ETH',
    image: '/assets/images/svg-icons/tether-gold.svg',
    address: '0x68749665ff8d2d112fa859aa293f07a622782f38',
    chainId: environment.eth.chainIdInt,
    decimal: 6,
    // XAUt -> USDT -> WETH
    routerPath: ['0x68749665ff8d2d112fa859aa293f07a622782f38', '0xdac17f958d2ee523a2206206994597c13d831ec7', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [500, 500], // XAUt-USDT, USDT-WETH
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'CRO',
    symbol: 'CRO',
    category: 'ETH',
    image: '/assets/images/svg-icons/cronos.svg',
    address: '0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b',
    chainId: environment.eth.chainIdInt,
    decimal: 8,
    routerPath: ['0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [10000],
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'Pepe',
    symbol: 'PEPE',
    category: 'ETH',
    image: '/assets/images/svg-icons/pepe-eth.svg',
    address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'FLOKI',
    symbol: 'Floki',
    category: 'ETH',
    image: '/assets/images/svg-icons/floki-with-eth.svg',
    address: '0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E',
    chainId: environment.eth.chainIdInt,
    decimal: 9,
    routerPath: ['0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  // ============================ BSC ============================
  {
    name: 'Cardano Token',
    symbol: 'ADA',
    category: 'BNB',
    image: '/assets/images/svg-icons/cardano.svg',
    address: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'ChainLink Token',
    symbol: 'LINK',
    category: 'BNB',
    image: '/assets/images/svg-icons/link-token.svg',
    address: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Zcash Token',
    symbol: 'ZEC',
    category: 'BNB',
    image: '/assets/images/svg-icons/zcash.svg',
    address: '0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    // ZEC -> USDT(BSC) -> WBNB
    routerPath: ['0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb', '0x55d398326f99059ff775485246999027b3197955', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [2500, 100], // ZEC-USDT, USDT-WBNB
    functionName: 'quoteExactInput', // v3
  },
  {
    name: 'Bitcoin Cash Token',
    symbol: 'BCH',
    category: 'BNB',
    image: '/assets/images/svg-icons/bitcoin-cash.svg',
    address: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 3,
    enumVersion: 1,
    pathFees: [2500],
    functionName: 'quoteExactInput', // v3
  },
  // ============================ Stables ============================
  {
    name: 'USDS Stablecoin',
    symbol: 'USDS',
    category: 'ETH',
    image: '/assets/images/svg-icons/usds.svg',
    address: '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Dai Stablecoin',
    symbol: 'DAI',
    category: 'ETH',
    image: '/assets/images/svg-icons/dai-token.svg',
    address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'World Liberty USD',
    symbol: 'USD1',
    category: 'ETH',
    image: '/assets/images/svg-icons/usd1.svg',
    address: '0x8d0d000ee44948fc98c9b98a4fa4921476f08b0d',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'USDe',
    symbol: 'USDe',
    category: 'ETH',
    image: '/assets/images/svg-icons/usde.svg',
    address: '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    chainId: environment.eth.chainIdInt,
    decimal: 18,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'PayPal USD',
    symbol: 'PYUSD',
    category: 'ETH',
    image: '/assets/images/svg-icons/pyusd.svg',
    address: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8',
    chainId: environment.eth.chainIdInt,
    decimal: 6,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Global Dollar',
    symbol: 'USDG',
    category: 'ETH',
    image: '/assets/images/svg-icons/usdg.svg',
    address: '0xe343167631d89b6ffc58b88d6b7fb0228795491d',
    chainId: environment.eth.chainIdInt,
    decimal: 6,
    routerPath: ['0x6982508145454ce325ddbe47a25d4ec3d2311933', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'Dai Token',
    symbol: 'DAI',
    category: 'BNB',
    image: '/assets/images/svg-icons/dai-token.svg',
    address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0x3EE2200Efb3400fAbB9AaCf31297cBDD1d435D47', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'World Liberty USD',
    symbol: 'USD1',
    category: 'BNB',
    image: '/assets/images/svg-icons/usd1.svg',
    address: '0x8d0d000ee44948fc98c9b98a4fa4921476f08b0d',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0x3EE2200Efb3400fAbB9AaCf31297cBDD1d435D47', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
  {
    name: 'USDe',
    symbol: 'USDe',
    category: 'BNB',
    image: '/assets/images/svg-icons/usde.svg',
    address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    chainId: environment.bsc.chainIdInt,
    decimal: 18,
    routerPath: ['0x3EE2200Efb3400fAbB9AaCf31297cBDD1d435D47', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    isExternal: true,
    tokenValUsd: 0,
    tokenPerNative: 0,
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 2,
    version: 2,
    enumVersion: 0,
    pathFees: [],
    tokenType: 'stable',
    functionName: 'getAmountsOut', // v2
  },
];

export const tokenList: ITokenData[] = environment.production ? externalTokenListMain : externalTokenListTest;

export const nativeList: ITokenData[] = [
  // --- Ethereum (ETH) ---
  {
    name: 'Ethereum',               //0                                        //  1
    symbol: 'ETH',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_drop.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 10,
    isExternal: false
  },
  {             //0
    name: 'Tether USD',             //1
    symbol: 'USDT',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_usdt_dropdown.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },
  {
    name: 'USD Coin',             //2
    symbol: 'USDC',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/usdc_eth.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },

  // --- Binance Smart Chain (BNB) ---
  {
    name: 'Binance Coin',             //3
    symbol: 'BNB',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/bnb-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    isExternal: false
  },
  {
    name: 'Tether USD',             //4
    symbol: 'USDT',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdt-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },
  {
    name: 'USD Coin',             //5
    symbol: 'USDC',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdc_bsc.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },
  {
    name: 'SOL',              //6
    symbol: 'SOL',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/sol_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    otherSymbol: "Solana",
    isExternal: false
  },
  {
    name: 'USDT Coin',              //7
    symbol: 'USDT',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/usdt_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },
  {
    name: 'USD Coin',             //8
    symbol: 'USDC',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/usdc_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
    isExternal: false
  },

  // --- Polygon (POL) ---
  {
    name: 'Polygon',              //9
    symbol: 'POL',
    category: 'POL',
    chainId: environment.polygon.chainIdInt,
    image: '/assets/images/svg-icons/pol_polygon.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 18,
    isExternal: false
  },
  {
    name: 'Tether USD',             //10
    symbol: 'USDT',
    category: 'POL',
    chainId: environment.polygon.chainIdInt,
    image: '/assets/images/svg-icons/usdt_polygon.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    isExternal: false
  },
  {
    name: 'USD Coin',             //11
    symbol: 'USDC',
    category: 'POL',
    chainId: environment.polygon.chainIdInt,
    image: '/assets/images/svg-icons/usdc_polygon.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    isExternal: false
  },

  // --- Arbitrum (ARB) ---
  {
    name: 'Ethereum',             //12
    symbol: 'ETH',
    category: 'ARB',
    chainId: environment.arbitrum.chainIdInt,
    image: '/assets/images/svg-icons/eth_arb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 18,
    isExternal: false
  },
  {
    name: 'Arbitrum',             //13
    symbol: 'ARB',
    category: 'ARB',
    chainId: environment.arbitrum.chainIdInt,
    image: '/assets/images/svg-icons/arb_arb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 18,
    isExternal: false
  },
  {
    name: 'USD Coin',             //14
    symbol: 'USDC',
    category: 'ARB',
    chainId: environment.arbitrum.chainIdInt,
    image: '/assets/images/svg-icons/usdc_arb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    isExternal: false
  },
  {
    name: 'Tether USD',             //15
    symbol: 'USDT',
    category: 'ARB',
    chainId: environment.arbitrum.chainIdInt,
    image: '/assets/images/svg-icons/usdt_arb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    isExternal: false
  },
];

export const generateTokenRouterData = (walletAddress: string) => {
  let data: any = [];
  for (let token of tokenList) {
    const isV3 = token.version === 3;
    data.push({
      ...getRouterContract(token.chainId as any, token.version as number),
      // v2: getAmountsOut(amountIn, address[] path) ; v3: quoteExactInput(bytes path, amountIn)
      functionName: isV3 ? 'quoteExactInput' : token.functionName || 'getAmountsOut',
      chainId: token.chainId, // 21
      args: isV3 ? [encodeV3Path(token.routerPath as string[], token.pathFees as number[]), BigInt(Math.pow(10, token.decimal as number))] : [Math.pow(10, token.decimal as number), token.routerPath],
    });
    data.push({
      address: token.address as any,
      abi: ERC_20_TOKEN.abi,
      functionName: 'balanceOf', // this method is returning the token balance
      chainId: token.chainId, // 22
      args: [walletAddress || '0x0000000000000000000000000000000000000000'],
    });
  }
  return data;
};

export const getRouterContract = (chainId: number, version: number) => {
  let contract: any = { ...multiRouterContract };
  switch (chainId) {
    case environment.eth.chainIdInt as any:
      contract.address = version === 2 ? environment.PUBLIC_ETH_ROUTER_ADDRESS_v2 : environment.PUBLIC_ETH_ROUTER_ADDRESS_v3;
      return contract;

    case environment.bsc.chainIdInt as any:
      contract.address = version === 2 ? environment.PUBLIC_BSC_ROUTER_ADDRESS_v2 : environment.PUBLIC_BSC_ROUTER_ADDRESS_v3;
      return contract;

    default:
      contract.address = version === 2 ? environment.PUBLIC_ETH_ROUTER_ADDRESS_v2 : environment.PUBLIC_ETH_ROUTER_ADDRESS_v3;
      return contract;
  }
};

export const processTokenData = (startIndex = 0, presaleItem = [] as any) => {
  // console.log("/n **** processTokenData ********/n", presaleItem, startIndex);
  const list = tokenList;
  for (let index in list) {
    const token = list[index];
    const quoteResult = presaleItem[startIndex + +index * 2]?.result;
    try {
      let perNativeRaw: any;
      if (token.version === 3) {
        // quoteExactInput returns [amountOut, sqrtPriceX96AfterList, initializedTicksCrossedList, gasEstimate]
        perNativeRaw = Array.isArray(quoteResult) ? quoteResult[0] : quoteResult;
      } else {
        // getAmountsOut returns uint256[] amounts; native out is the last hop
        const lastIndx = token.routerPath ? token.routerPath.length - 1 : 0;
        perNativeRaw = quoteResult?.[lastIndx];
      }
      token.tokenPerNative = +formatUnits(perNativeRaw || 0, 18);
      const tokenBalance = Number(presaleItem[startIndex + +index * 2 + 1]?.result || 0);
      token.tokenBalance = tokenBalance / Math.pow(10, token.decimal as number) || 0;
    } catch (e) {
      console.log('Failed for token ' + token.name, e);
    }
  }
  return list;
};



export const encodeV3Path = (path: string[] = [], fees: number[] = []): `0x${string}` => {
  let out = (path[0] || '').toLowerCase().replace(/^0x/, '');
  for (let i = 0; i < fees.length; i++) {
    out += (fees[i] >>> 0).toString(16).padStart(6, '0'); // uint24 fee, 3 bytes
    out += (path[i + 1] || '').toLowerCase().replace(/^0x/, '');
  }
  return `0x${out}` as `0x${string}`;
};

export const getTokenContracts = (address:string) => {
  const externalTokenContract = generateTokenRouterData(address);
  return  externalTokenContract ;
}
